import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../api/axiosInstance";

export const fetchProductList = createAsyncThunk(
  "product/fetchProductList",
  async (payload = {}, { rejectWithValue }) => {
    try {
      // Default payload structure
      const defaultPayload = {
        product_type: "default",
        order_sub_type_id: "0",
        status: "",
        visibility_info: 0,
      };
      const finalPayload = { ...defaultPayload, ...payload };
      if (finalPayload.product_id === "") {
        delete finalPayload.product_id;
      }

      // Remove empty values from payload
      const cleanPayload = {};
      Object.entries(finalPayload).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") {
          cleanPayload[key] = value;
        }
      });
      const { data } = await axiosInstance({
        method: "GET",
        url: "/products/",
        params: cleanPayload,
        headers: {
          "Content-Type": "application/json",
        },
      });

      return data;
    } catch (error) {
      return rejectWithValue("Failed to fetch product list");
    }
  }
);

export const fetchCategoriesList = createAsyncThunk(
  "product/fetchCategoriesList",
  async (payload = {}, { rejectWithValue }) => {
    try {
      // Default payload structure
      const defaultPayload = {
        category_type: "default",
        status: 1,
        order_sub_type_id: "0",
      };
      const finalPayload = { ...defaultPayload, ...payload };

      // Remove empty values from payload
      const cleanPayload = {};
      Object.entries(finalPayload).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") {
          cleanPayload[key] = value;
        }
      });

      const { data } = await axiosInstance({
        method: "GET",
        url: "/categories/list",
        params: cleanPayload,
        headers: {
          "Content-Type": "application/json",
        },
      });

      return data;
    } catch (error) {
      return rejectWithValue("Failed to fetch categories list");
    }
  }
);

export const fetchProductDetailsById = createAsyncThunk(
  "product/fetchProductDetailsById",
  async (payload, { rejectWithValue }) => {
    try {
      const { product_id } = payload;
      const { data } = await axiosInstance.get(
        `/products/?visibility_info=1&order_sub_type_id=0&product_id=${product_id}&total_sold_quantity=1&activity_logs=true`
      );
      return data; // Return the entire response data
    } catch (error) {
      // Return error message from the response if available, otherwise a generic one
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch product details."
      );
    }
  }
);

export const fetchBestSellerProductsList = createAsyncThunk(
  "product/fetchBestSellerProductsList",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.get(
        `/products/bestsellers?limit=10`
      );
      return data;
    } catch (error) {
      return rejectWithValue("Failed to fetch user");
    }
  }
);

// get delivery partnet products
export const fetchDeliveryPartnersProducts = createAsyncThunk(
  "product/fetchDeliveryPartnersProducts",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.post(`/products/list/`, payload);
      return data;
    } catch (error) {
      return rejectWithValue("Failed to fetch delivery partner products");
    }
  }
);

// Fetch preferences data
export const fetchPreferences = createAsyncThunk(
  "product/fetchPreferences",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.get(
        `/products/preference-info?preference_type=preference`
      );
      return data;
    } catch (error) {
      return rejectWithValue("Failed to fetch preferences");
    }
  }
);

// Fetch cuts data
export const fetchCuts = createAsyncThunk(
  "product/fetchCuts",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.get(
        `/products/preference-info?preference_type=cut`
      );

      return data;
    } catch (error) {
      return rejectWithValue("Failed to fetch cuts");
    }
  }
);

// remove a visibility option
export const removeVisibility = createAsyncThunk(
  "product/removeVisibility",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.post(
        `/products/remove-order-type`,
        payload
      );
      return data;
    } catch (error) {
      return rejectWithValue("Failed to remove visibility");
    }
  }
);

// Best seller products

export const updateBestSellerPosition = createAsyncThunk(
  "products/updateBestSellerPosition",
  async ({ bestseller_id, bestseller_order }, { rejectWithValue }) => {
    try {
      const payload = {
        bestseller_id: [bestseller_id], // Array format as required
        bestseller_order,
      };
      const { data } = await axiosInstance.post(
        `/products/bestseller/update-position`,
        payload
      );
      return { bestseller_id, bestseller_order, data };
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to update bestseller position"
      );
    }
  }
);
